import {
    cardPaymentUrl,
    paymentFailureUrl,
    paymentSuccessUrl,
    planChoosePlanUrl,
    planGetPlusUrl,
    planGetProUrl,
    planPlanForUrl,
    smsPaymentUrl,
} from "@/mk2/apps/plan/urls";
import { Route } from "@/mk2/containers/Application/Application";

export const routes: Route[] = [
    {
        app: "plan",
        path: planGetPlusUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/plan/containers/GetPlus/GetPlusPage" /* webpackChunkName: "plus.GetPlus" */
            );
        },
        modules: ["@/mk2/apps/plus/containers/GetPlus/GetPlusPage"],
    },
    {
        app: "plan",
        path: planGetProUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/plan/containers/GetPro/GetProPage" /* webpackChunkName: "plus.GetPro" */
            );
        },
        modules: ["@/mk2/apps/plus/containers/GetPro/GetProPage"],
    },
    {
        app: "plan",
        path: planChoosePlanUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/plan/containers/PlanChoose/PlanChoosePage" /* webpackChunkName: "plus.PlanChoose" */
            );
        },
        modules: ["@/mk2/apps/plus/containers/PlanChoose/PlanChoosePage"],
    },
    {
        app: "plan",
        path: planPlanForUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/plan/containers/PlanFor/PlanForPage" /* webpackChunkName: "plus.PlanFor" */
            );
        },
        modules: ["@/mk2/apps/plus/containers/PlanFor/PlanForPage"],
    },
    {
        // uspesna platba
        app: "plan",
        path: paymentSuccessUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/plan/containers/PaymentSuccess/PaymentSuccessPage" /* webpackChunkName: "plan.PaymentSuccess" */
            );
        },
        modules: ["@/mk2/apps/plus/containers/PaymentSuccess/PaymentSuccessPage"],
    },
    {
        // neuspesna platba
        app: "plan",
        path: paymentFailureUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/plan/containers/PaymentFailure/PaymentFailurePage" /* webpackChunkName: "plan.PaymentFailure" */
            );
        },
        modules: ["@/mk2/apps/plus/containers/PaymentFailure/PaymentFailurePage"],
    },
    {
        // cakanie platby
        app: "plan",
        path: smsPaymentUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/plan/containers/SmsPayment/SmsPaymentPage" /* webpackChunkName: "plan.SmsPayment" */
            );
        },
        modules: ["@/mk2/apps/plus/containers/SmsPayment/SmsPaymentPage"],
    },
    {
        app: "plan",
        path: cardPaymentUrl,
        getPage: () => {
            return import(
                "@/mk2/apps/plan/containers/CardPayment/CardPaymentPage" /* webpackChunkName: "plus.CardPayment" */
            );
        },
        modules: ["@/mk2/apps/plus/containers/CardPayment/CardPaymentPage"],
    },
];
